// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_s0-0";
export var checkoutRateBadgeLink = "_s0-1";